;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { ProviderType } from "@/types/dataProvider";

export const PROVIDER_NAMES: Record<string, string> = {
	APP_FOOLIO: "AppFolio Reporting API",
	APPFOLIO_DATABASE: "AppFolio Database API",
	ASANA: "Asana",
	CALL_LINKS: "Call Links (VoIP)",
	GADMIN: "Google Admin",
	GMELIUS: "Gmelius",
	GOTO_CONNECT: "GoTo Connect",
	OPINIION: "Opiniion",
	PODIUM: "Podium",
	QUICKBOOKS: "QuickBooks",
	RENTENGINE: "RentEngine",
	RENTVINE: "Rentvine",
	SHOWMOJO: "ShowMojo",
	YARDI: "Yardi",
	ZOOM: "Zoom",
};

export function getProviderDisplayName(providerType: string): string {
	return PROVIDER_NAMES[providerType] ?? providerType;
}

export function formatProviderTypeTokens(text: string): string {
	return text.replace(
		new RegExp(`\\b(?:${Object.keys(PROVIDER_NAMES).join("|")})\\b`, "g"),
		(providerType) => PROVIDER_NAMES[providerType] ?? providerType,
	);
}

export const INTEGRATIONS_LOCAL_STORAGE_KEYS = {
	GOTO_CONNECT: "integrations:goto:pathname",
	PODIUM: "integrations:podium:pathname",
	QUICKBOOKS: "integrations:qb:pathname",
	ZOOM: "integrations:zoom:pathname",
};

export const NON_EDITABLE_PROVIDERS: ProviderType[] = [
	ProviderType.GOTO_CONNECT,
	ProviderType.PODIUM,
	ProviderType.QUICKBOOKS,
	ProviderType.ZOOM,
];
